import { render, staticRenderFns } from "./TagManagementPage.vue?vue&type=template&id=260820be&scoped=true"
import script from "./TagManagementPage.vue?vue&type=script&lang=js"
export * from "./TagManagementPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "260820be",
  null
  
)

export default component.exports